module.exports = __webpack_public_path__ + "static/ambasador_homa-2209da8593af0ec85109eb857df7dc31.png";